// extracted by mini-css-extract-plugin
export default {"Placeholder":"X5kyRedn"};